<div class="free-search-container">
    <div class="icon-wrapper">
        <img src="assets/icons/magnifying-glass.svg">
    </div>
    <input class="free-search-input" (input)="search($event.target.value)" [(ngModel)]="currentSearch.searchTerm" 
        placeholder="Search" name="free-search" autocomplete="off"/>
    <div class="free-search-divider"></div>
    <custom-dropdown-list-container class="free-search-dropdown" [(isDropdownOpen)]="isDropdownOpen">
        <div class="free-search-toggle" dropdown-toggle>
            <div class="free-search-selection">
                {{currentSearch?.property?.name}}
            </div>
            <div class="icon-wrapper free-search-arrow-wrapper">
                <img src="assets/icons/solid-arrow.svg">
            </div>
        </div>
        <div dropdown-list class="free-search-items">
            <div class="free-search-item-wrapper" *ngFor="let option of searchOptions" (click)="selectOption(option)">
                <div class="free-search-item" [class.free-search-selected]="currentSearch?.property?.id === option.id" >
                    {{option.name}}
                </div>
            </div>
        </div>
    </custom-dropdown-list-container>
</div>
